export default __webpack_public_path__ + "static/media/bck1.aaa5afc9.png";